import React, { useState, useEffect } from "react";
import "../styles/nimbly2.css";
import pole1 from "../assets/images/pole1.jpg";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useProject } from '../contexts/ProjectContext';
import { useEnvironmentConfigContext } from '../contexts/EnvironmentConfigContext';
import loadinggif from "../assets/loading.gif";
import loadingtext from "../assets/loadingmaps.png";

const ExpandedUGPole = ({ item }) => {
    //console.log("load popup", item);

    const { selectedProject, GCP_Project, Dataset_ID } = useProject();
    const { environmentConfig } = useEnvironmentConfigContext();
    const [loading, setLoading] = React.useState(false);
    const [pole, setPole] = React.useState(null);

    useEffect(() => {
        if (selectedProject && GCP_Project && Dataset_ID) {
            populatePolePopupData();
        }
    }, [selectedProject, GCP_Project, Dataset_ID]);

    const populatePolePopupData = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_WEB_API_URL}/api-common/poles/UGPoleLookup`, {
            method: 'POST',
            headers: {
                'frontendenvironmentconfig': environmentConfig,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Dataset_ID: Dataset_ID,
                GCP_Project: GCP_Project,
                Project: selectedProject,
                GlobalID: item.info.GlobalID
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                //console.log(data);

                const markerList = [];
                //for (var index in data) {
                    var pole = data;
                    var obj = {};
                    var poleInfo = {};
                    poleInfo["Audit_User"] = null;
                    poleInfo["Audit_Date"] = null;
                    let lat = 0;
                    let long = 0;
                    if (pole && pole.fieldDict && pole.fieldDict.Location_Details && pole.fieldDict.Location_Details.Coordinates) {

                        let arr = pole.fieldDict.Location_Details.Coordinates.split("-");
                        if (arr.length == 2) {

                            lat = Number(arr[0]);
                            long = -(Number(arr[1]));
                        }
                    }


                    if (pole && pole.fieldDict && pole.fieldDict.Poles && pole.fieldDict.Poles.Pole_Number) {
                        poleInfo["info"].Photos = pole.photosDict;
                    }

                    poleInfo["info"] = pole && pole.fieldDict && pole.fieldDict.Poles ? pole.fieldDict.Poles : null;
                    poleInfo["Attachers"] = pole && pole.attachmentsDict && pole.attachmentsDict ? Object.values(pole.attachmentsDict) : [];

                    obj["lat"] = lat;
                    obj["lng"] = long;

                    poleInfo["allData"] = data;

                    poleInfo["coords"] = obj;


                    poleInfo.info = {

                    }
                    poleInfo["info"].Lat = lat.toString();
                    poleInfo["info"].Long = long.toString();
                    if (pole && pole.fieldDict && pole.fieldDict.Poles && pole.fieldDict.Poles.Audit_User) {
                        poleInfo["Audit_User"] = pole.fieldDict.Poles.Audit_User;
                    }
                    if (pole && pole.fieldDict && pole.fieldDict.Poles && pole.fieldDict.Poles.Audit_Date) {
                        poleInfo["Audit_Date"] = pole.fieldDict.Poles.Audit_Date;
                    }
                    if (pole && pole.fieldDict && pole.fieldDict.Poles && pole.fieldDict.Poles["Pole Status"]) {
                        poleInfo["info"]["Pole_Status"] = pole.fieldDict.Poles["Pole Status"];
                    }
                    if (pole && pole.fieldDict && pole.fieldDict.Poles && pole.fieldDict.Poles["Pole Number"]) {
                        poleInfo["info"].Pole_Number = pole.fieldDict.Poles["Pole Number"];
                    }
                    if (pole && pole.fieldDict && pole.fieldDict.Poles && pole.fieldDict.Poles.GlobalID) {
                        poleInfo["info"].Globslid = pole.fieldDict.Poles.GlobalID;
                    }

                    markerList.push(poleInfo);
                //}
                //console.log("pole", markerList);
                setPole(markerList.length > 0 ? markerList[0] : null)
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }
    // console.log(pole.allData.fieldDict);
    //console.log("here");
    return (
        <div className="nimbly-pole-popup-wrapper">
            <header className="nimbly-pole-popup-header">
                {"Structure ID: "+item.info["StructureID"]}
            </header>
            <div className='nimbly-pole-popup-info-container'>
                {loading ? <div className='nimbly-pole-popup-info-loading-img'><img className='nimbly2-map-loader-gif' src={loadinggif} /></div> 
                    : (pole == null ? "No Data"
                        : <div >
                <div className="nimbly-pole-popup-img-wrapper">
                    {/* Image Containers */}
                    {!(pole.allData && pole.allData.photosDict != null && Object.values(pole.allData.photosDict).length > 0) ? <div>
                        No Photos
                            </div> : Object.values(pole.allData.photosDict) ?.map((photo, x) => (
                            <div className="nimbly-pole-img-container-ug">
                                <a target="_blank" href={photo["Photo Path"]} rel="noreferrer"><img src={photo["Photo Path"]} alt="Pole" /></a>
                                {Object.keys(photo).filter(x => x === "Photo Name") ?.map(photoField => (
                                    <GridLayoutItem><strong>{photoField}</strong>:{photo[photoField]}</GridLayoutItem>
                                )
                                )}
                            </div>
                        ))}
                </div>
                <div className="nimbly-pole-details-wrapper">
                    {!(pole["allData"] && pole["allData"].fieldDict != null && Object.keys(pole.allData.fieldDict) != null) ? <div>
                        No Pole Data
                            </div>
                        : 
                        <>
                            <section className="nimbly-pole-details-section">
                                <GridLayout
                                    gap={{
                                        rows: 5,
                                        cols: 2,
                                    }}
                                    cols={[
                                        {
                                            width: "50%",
                                        },
                                        {
                                            width: "50%",
                                        }
                                    ]}
                                >
                                    <GridLayoutItem className="pulse-expand-title-ug" row={1} col={1} colSpan={2}>
                                        Pole Status
                                    </GridLayoutItem>
                                            <GridLayoutItem className="pulse-expand-title-ug-symbology" row={2} col={1} colSpan={2}>
                                                {pole.allData.fieldDict.Poles.Symbology}
                                            </GridLayoutItem>

                                </GridLayout>
                            </section>
                                <section className="nimbly-pole-details-section">
                                <GridLayout
                                    gap={{
                                        rows: 20,
                                        cols: 2,
                                    }}
                                    cols={[
                                        {
                                            width: "50%",
                                        },
                                        {
                                            width: "50%",
                                        }
                                    ]}
                                >
                                    <GridLayoutItem className="pulse-expand-title-ug" row={1} col={1} colSpan={2}>
                                        Pole Overview
                                    </GridLayoutItem>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug" row={2} col={1}>
                                                Sturcture ID
                                            </GridLayoutItem>
                                            <GridLayoutItem row={2} col={2}>
                                                {pole.allData.fieldDict.Poles["Structure ID"]}
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug-linebreak" row={2} col={1} colSpan={2} />

                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug" row={3} col={1}>
                                                Alt Sturcture ID
                                            </GridLayoutItem>
                                            <GridLayoutItem row={3} col={2}>
                                                {pole.allData.fieldDict.Poles["Alternate Structure ID"]}
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug-linebreak" row={3} col={1} colSpan={2} />

                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug" row={4} col={1}>
                                                Feeder ID
                                            </GridLayoutItem>
                                            <GridLayoutItem row={4} col={2}>
                                                {pole.allData.fieldDict.Poles["Feeder ID"]}
                                            </GridLayoutItem>
                                                                                        <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug-linebreak" row={4} col={1} colSpan={2} />


                                </GridLayout>
                            </section>
                        {Object.keys(pole.allData.fieldDict) ?.map((tableName, tableIndex) => (

                            <section className="nimbly-pole-details-section">
                                <GridLayout
                                    gap={{
                                        rows: 20,
                                        cols: 2,
                                    }}
                                    cols={[
                                        {
                                            width: "50%",
                                        },
                                        {
                                            width: "50%",
                                        }
                                    ]}
                                >
                                    <GridLayoutItem className="pulse-expand-title-ug" row={1} col={1} colSpan={2}>
                                        {tableName == "Poles" ? "Other" : tableName}
                                    </GridLayoutItem>
                                    {Object.keys(pole.allData.fieldDict[tableName]).filter(x => x !== "Symbology" && x !== "Structure ID"&& x !== "Alternate Structure ID"&& x !== "Feeder ID") ?.map((fieldName, fieldIndex) => (
                                        <>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column" row={fieldIndex + 2} col={1}>
                                                {fieldName}
                                            </GridLayoutItem>
                                            <GridLayoutItem row={fieldIndex + 2} col={2}>
                                                {pole.allData.fieldDict[tableName][fieldName]}
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column-ug-linebreak" row={fieldIndex + 2} col={1} colSpan={2}>
                                            </GridLayoutItem>
                                        </>
                                    ))}


                                </GridLayout>
                            </section>



                        )
                        )}
                        </>
                        }
                    {pole.Attachers == null ? null :
                        pole.Attachers ?.map((attacher, x) => (
                            <section className="nimbly-pole-details-section">
                                <GridLayout
                                    gap={{
                                        rows: Object.keys(attacher) ? Object.keys(attacher).length : 0,
                                        cols: 2,
                                    }}
                                    cols={[
                                        {
                                            width: "50%",
                                        },
                                        {
                                            width: "50%",
                                        }
                                    ]}
                                >

                                    <GridLayoutItem className="pulse-expand-title-ug" row={1} col={1} colSpan={2}>
                                        Attacher Information {x + 1}
                                    </GridLayoutItem>
                                    {Object.keys(attacher) ?.map((key, index) => (
                                        <>
                                            <GridLayoutItem className="pulse-queryresult-expanded-detail-column" row={index + 2} col={1}>
                                                {key}
                                            </GridLayoutItem>
                                            <GridLayoutItem row={index + 2} col={2}>
                                                {attacher[key]}
                                            </GridLayoutItem>
                                        </>
                                    ))}


                                </GridLayout>
                            </section>


                        ))}
                </div>
                        </div>)}
            </div>
        </div>
    );
};

export default ExpandedUGPole;
